import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import Loading from "../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

const Field = ({ label, value }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
    <div style={{ fontSize: '0.72rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#adb5bd' }}>
      {label}
    </div>
    <div style={{ fontSize: '0.9rem', color: '#1a1d23', fontWeight: 500 }}>
      {value || <span style={{ color: '#ced4da' }}>—</span>}
    </div>
  </div>
);

export const ProfileComponent = () => {
  const { user } = useAuth0();

  return (
    <div style={{ paddingBottom: '3rem' }}>
      <div className="mb-4">
        <h2 className="page-title mb-1">Profile</h2>
        <p className="page-subtitle">Your account details</p>
      </div>

      <Row className="g-3">
        {/* Avatar + name card */}
        <Col xs={12} md={4}>
          <Card style={{ border: '1px solid #e9ecef', borderRadius: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.05)', height: '100%' }}>
            <CardBody style={{ padding: '2rem 1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <img
                src={user.picture}
                alt="Profile"
                style={{ width: '88px', height: '88px', borderRadius: '50%', objectFit: 'cover', marginBottom: '1rem', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
              />
              <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#1a1d23', marginBottom: '0.25rem' }}>
                {user.name}
              </div>
              <div style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '1rem' }}>
                {user.email}
              </div>
              {user.email_verified && (
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '3px 10px', borderRadius: '20px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', fontSize: '0.72rem', fontWeight: 600, color: '#16a34a' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  Verified
                </div>
              )}
            </CardBody>
          </Card>
        </Col>

        {/* Details card */}
        <Col xs={12} md={8}>
          <Card style={{ border: '1px solid #e9ecef', borderRadius: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.05)', height: '100%' }}>
            <CardBody style={{ padding: '1.75rem' }}>
              <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1a1d23', marginBottom: '1.25rem' }}>
                Account Information
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
                <Field label="Full Name" value={user.name} />
                <Field label="Nickname" value={user.nickname} />
                <Field label="Email" value={user.email} />
                <Field label="Email Verified" value={user.email_verified ? 'Yes' : 'No'} />
                <Field label="Auth Provider" value={user.sub?.split('|')[0]} />
                <Field label="User ID" value={user.sub?.split('|')[1]} />
                {user.updated_at && (
                  <Field
                    label="Last Updated"
                    value={new Date(user.updated_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                  />
                )}
                {user.locale && <Field label="Locale" value={user.locale} />}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
